import { ResponseService } from './../services/response.service';
import { LocalStorageService } from './../services/local-storage.service';
import { BreadcrumbsService } from './../services/breadcrumbs.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { BreadcrumbService } from 'ng2-breadcrumb/ng2-breadcrumb';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ApiService } from './../services/api.service';
import { AuthService } from './../services/auth.service';
import { ActivationService } from './../services/activation.service';
import { Response } from '@angular/http';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { CustomFormsModule, CustomValidators } from 'ng2-validation';
import { CustomDSValidators } from './../shared/validators/custom-validators';
import 'rxjs/add/operator/filter';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-main',
  templateUrl: './login.component.html',
})

export class LoginComponent implements OnInit {

  public loading: Boolean = false;

  public disabled = true;

  loginForm: FormGroup;

  activationButton: Boolean = false;

  subscriber: any;

  routeParamSub: any;

  redirectUrl: string = '';

  redirectInvoice: string = '';

  user: any;

  public registerURL: string = '/register';

  constructor(
    private authService: AuthService,
    private activationService: ActivationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    private notificationService: NotificationsService,
    private translateService: TranslateService,
    private breadcrumbsService: BreadcrumbsService,
    private responseService: ResponseService,
    private localStorageService: LocalStorageService
  ) {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, CustomDSValidators.staffEmail]),
      password: new FormControl('', [Validators.required])
    });
  }

  ngOnInit() {

    this.localStorageService.remove('company');

    this.routeParamSub = this.route.params.subscribe(params => {
      this.redirectUrl = params['redirect'];
      this.redirectInvoice = params['invoice'];
    });

    this.localStorageService.remove('company');

    this.loginForm.controls['email'].setValue('');
    this.loginForm.controls['email'].updateValueAndValidity();
  }

  login() {
    this.loading = true;
    this.activationButton = false;
    this.authService.login(this.loginForm.value, this.redirectUrl, this.redirectInvoice).subscribe(
      (auth) => {
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.responseService.error(error);
        if (error.status.code === 403 && error.status.message === 'user.activation_required') {
          this.user = error.data.email;
          this.activationButton = true;
          return;
        }
        this.loginForm.reset();
      }
    );
  }

  resendActiveLink() {
    this.activationService.sendActiveEmail(this.user).subscribe();
  }
}




// WEBPACK FOOTER //
// ./src/app/login/login.component.ts